const rDigit = /^\d+$/

export const checkArgs = (args) => {
  Object.keys(args).forEach((arg) => {
    if (args[arg] === undefined) throw new Error(`No ${arg} found!`)
  })
}

export const getQueryString = (obj) => {
  const entries = Object.entries(obj).filter(([, value]) => value)

  if (entries.length > 0) {
    const params = new URLSearchParams()
    entries.forEach(([key, value]) => {
      if (value) {
        params.set(key, value)
      }
    })
    return `?${params.toString()}`
  }

  return ''
}

export const numberReducer = (acc, id) => {
  if (!Array.isArray(acc)) {
    throw new Error('Accumulator is not an array')
  }

  if (rDigit.test(String(id))) {
    acc.push(Number.parseInt(id, 10))
  }

  return acc
}

export const strinc = (str, searchterm) => {
  str ||= ''

  if (rDigit.test(String(str)) && rDigit.test(String(searchterm))) {
    return String(str) === String(searchterm)
  }

  return str.toLowerCase().includes(searchterm.toLowerCase())
}
